export default __webpack_public_path__ + "static/media/9.862bfcb6.png";